function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState, useEffect, useRef } from 'react';

const TableData = ({
  name,
  type,
  onChange,
  state,
  ...props
}) => {
  const [showInput, setShowInput] = useState(false);
  const refInput = useRef(null);
  useEffect(() => {
    if (showInput) {
      refInput.current?.focus();
    }
  }, [showInput]);

  const handleDoubleClick = event => {
    setShowInput(true);
  };

  const handleBlur = () => {
    setShowInput(false);
  };

  return /*#__PURE__*/React.createElement("div", {
    "data-editable": showInput,
    onClick: props.disabled !== true ? handleDoubleClick : undefined
  }, /*#__PURE__*/React.createElement("input", _extends({
    ref: refInput
  }, props, {
    type: showInput ? type : 'hidden',
    name: name,
    value: state.value,
    onChange: onChange,
    onBlur: handleBlur
  })), showInput || /*#__PURE__*/React.createElement("span", {
    className: "muted-data"
  }, state.value));
};

TableData.defaultProps = {
  type: 'text'
};
export default TableData;